import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./api-client";

export const useLookupCashCenters = () =>
  useMutation({
    mutationFn: () => client(`lookups/cash/centers`),
  });

export const useLookupDenominations = () =>
  useMutation({
    mutationFn: (data) => client(`lookups/currency/denominations/${data}`),
  });

export const useLookupOffices = () =>
  useMutation({
    mutationFn: (id) => client(`lookups/cash/center/offices/${id}`),
  });

export const useLookupATMSites = () =>
  useMutation({
    mutationFn: (customerId) => client(`lookups/atm/sites/${customerId}`),
  });

export const useLookupCurrencyMultiples = () =>
  useMutation({
    mutationFn: (shortName) =>
      client(`lookups/currency/multiples/${shortName}`),
  });

export const useLookupCountries = () =>
  useMutation({
    mutationFn: () => client(`lookups/countries`),
  });
export const useLookupCities = () =>
  useMutation({
    mutationFn: (data) => client(`lookups/cities/${data}`),
  });
export const useLookupRegions = () =>
  useMutation({
    mutationFn: (countryCode) => client(`lookups/regions/${countryCode}`),
  });
export const useLookupEmirates = () =>
  useMutation({
    mutationFn: (countryCode) => client(`lookups/emirates/${countryCode}`),
  });
export const useLookupRoutesRegion = () =>
  useMutation({
    mutationFn: (region) => client(`lookups/routes/region/${region}`),
  });

export const useLookupBusinessUnits = () =>
  useMutation({
    mutationFn: () => client(`lookups/business/units`),
  });

export const useLookupAssignmentGroup = () =>
  useMutation({
    mutationFn: () => client(`lookups/assignment/groups`),
  });
export const useLookupMachinesServicePoints = () =>
  useMutation({
    mutationFn: (customerId) =>
      client(`lookups/customer/machine/sites/${customerId}`),
  });
export const useLookupPendingReasons = () =>
  useMutation({
    mutationFn: (category) => client(`lookups/pending/reasons/${category}`),
  });

export const useLookupCustomers = () =>
  useMutation({
    mutationFn: () => client("lookups/customers"),
  });

export const useLookupCashCenterRoutes = (cashCenterId) =>
  useQuery({
    queryKey: ["CashCenterRoutes", cashCenterId],
    queryFn: () => client(`lookups/routes/${cashCenterId}`),
  });

export const useLookupMachineTypes = () =>
  useMutation({
    mutationFn: () => client(`lookups/machine/types`),
  });
export const useLookupMachineMakers = () =>
  useMutation({
    mutationFn: () => client(`lookups/machine/makers`),
  });

export const useLookupMachineModel = () =>
  useMutation({
    mutationFn: (maker) => client(`lookups/machine/models/${maker}`),
  });

export const useLookupClients = () =>
  useMutation({
    mutationFn: () => client(`lookups/clients`),
  });
